export default __webpack_public_path__ + "static/media/Factory03.34a211be.jpg";